import React from 'react';
import PropTypes from 'prop-types';
//@ts-expect-error
import ImmutablePropTypes from 'react-immutable-proptypes';
import moment from 'moment';
import { Map, List } from 'immutable';

import SimpleDataTable from 'src/components/SimpleDataTable/SimpleDataTable';
import ManualSettlementForm from 'src/components/ManualSettlementForm/ManualSettlementForm';
import ParkBetForm from 'src/components/ParkBetForm/ParkBetForm';
import { CommentBetForm } from 'src/components/CommentBetForm/CommentBetForm';
import LegResultForm from 'src/components/LegResultForm/LegResultForm';

import { money } from 'src/utils/format';

import { COLUMNS, COLUMNS_WITH_SP } from './config.jsx';
import { AppStateComponent } from 'src/AppState/AppState';
import { Amount } from 'src_common/common/amount/Amount';
import { formatAmountWithCurrency } from 'src_common/common/amount/website-money/currency';
import { ActiveListElement } from './BetSearchResults.style';

const odds = require('odds-converter');

function convertLeg(leg) {
    leg = JSON.parse(JSON.stringify(leg));

    leg.price = leg.price && leg.price.f;
    leg.spPrice = leg.spPrice && leg.spPrice.f;

    if (!leg.eachWayReduction) {
        leg.eachWayReduction =
            leg.eachWayTerms &&
            leg.eachWayTerms.reduction &&
            `${leg.eachWayTerms.reduction.num}/${leg.eachWayTerms.reduction.den}`;
    }

    if (leg.result) {
        leg.type = leg.result.type;
        leg.winReduction = leg.result.winReduction && `${leg.result.winReduction.num}/${leg.result.winReduction.den}`;
        leg.placeReduction =
            leg.result.placeReduction && `${leg.result.placeReduction.num}/${leg.result.placeReduction.den}`;
        leg.r4Deductions = leg.result.r4Deductions;
        leg.place = leg.result.place;
    }

    return leg;
}

class BetSearchResults extends AppStateComponent {
    static propTypes = {
        manualSettlements: ImmutablePropTypes.map,
        payouts: ImmutablePropTypes.map,
        competitions: ImmutablePropTypes.map,
        sports: ImmutablePropTypes.map,
        bets: ImmutablePropTypes.map,
        rules: ImmutablePropTypes.map,
        list: ImmutablePropTypes.list,
        permissions: ImmutablePropTypes.map,
        bonusList: ImmutablePropTypes.list,

        isSpColumn: PropTypes.bool,

        onSettleManuallyRequest: PropTypes.func.isRequired,
        onCommentBetRequest: PropTypes.func.isRequired,
        onParkBetRequest: PropTypes.func.isRequired,
        onCancelBetRequest: PropTypes.func.isRequired,
        onSettleBetRequest: PropTypes.func.isRequired,
        onCalculatePayoutRequest: PropTypes.func.isRequired,
        onBetUnsettlementRequest: PropTypes.func.isRequired,
        onQueryAuditsRequest: PropTypes.func.isRequired,
    };

    static defaultProps = {
        manualSettlements: Map(),
        payouts: Map(),
        competitions: Map(),
        sports: Map(),
        bets: Map(),
        rules: Map(),
        bonusList: List(),
    };

    constructor(props, context) {
        super(props, context);

        this.state = this.getState(props);
        this.results = {};
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState(this.getState(props));
    }

    getState(props) {
        return {
            bets: props.list.map((id) => props.bets.get(id)).toJS(),
            isonisValue: [],
        };
    }

    setIsonisValue = (legId, betId, value) => {
        const isonisStateValue = this.state.isonisValue;

        isonisStateValue.push({
            betId,
            legId,
            comment: value,
        });

        const duplicatesIndex = [];

        isonisStateValue.forEach((item, index) => {
            if (item.legId === legId) {
                duplicatesIndex.push(index);
            }
        });

        if (duplicatesIndex.length > 1) {
            isonisStateValue.splice(duplicatesIndex[0], 1);
        }

        this.setState({
            isonisValue: isonisStateValue,
        });
    };

    getIsonisValue = () => {
        return this.state.isonisValue;
    };

    settleManually(id, amount) {
        this.props.onSettleManuallyRequest(id, this.props.bets.getIn([id, 'account', 'id']), amount);
    }

    parkBet(id, status) {
        this.props.onParkBetRequest(id, this.props.bets.getIn([id, 'account', 'id']), status);
    }

    cancelBet(id) {
        this.props.onCancelBetRequest(id, this.props.bets.getIn([id, 'account', 'id']));
    }

    commentBet = (id, comment) => {
        this.props.onCommentBetRequest(id, this.props.bets.getIn([id, 'account', 'id']), comment);
    };

    settleBet(bet) {
        const result = this.getLegResults(bet);

        if (result.errors.length > 0) {
            // TODO: make proper error message later
            return window['a' + 'lert'](result.errors.join('\n'));
        }

        this.props.onSettleBetRequest(bet.id, bet.account.id, result.legs);
    }

    unsettleBet(bet) {
        this.props.onBetUnsettlementRequest(bet.id, bet.account.id);
    }

    calculateBetPayout(bet) {
        const result = this.getLegResults(bet);

        if (result.errors.length === 0) {
            this.props.onCalculatePayoutRequest(bet.id, bet.account.id, result.legs);
        }
    }

    getLegResults(bet) {
        const results = this.results[bet.id] || {};

        const legs = JSON.parse(JSON.stringify(bet.legs));

        const errors = {};

        Object.keys(results).forEach((index) => {
            const result = results[index];
            const leg = legs[index];

            leg.result = {
                type: result.type,
            };

            if (result.type === 'place') {
                leg.result.place = result.place;
            }

            if (result.price) {
                if (!leg.price || leg.price.f !== result.price) {
                    if (result.price.includes('/')) {
                        const fractionPrice = result.price.split('/');
                        leg.price = {
                            f: result.price,
                            d: odds.fraction.toDecimal(fractionPrice[0], fractionPrice[1]),
                        };
                    } else if (!result.price.includes('/')) {
                        const fraction = odds.decimal.toFractional(result.price).simplify();
                        leg.price = {
                            f: fraction.n + '/' + fraction.d,
                            d: parseFloat(result.price, 10),
                        };
                    }
                }
            }

            if (result.spPrice) {
                if (!leg.spPrice || leg.spPrice.f !== result.spPrice) {
                    if (result.spPrice.includes('/')) {
                        const fractionPrice = result.spPrice.split('/');
                        leg.spPrice = {
                            f: result.spPrice,
                            d: odds.fraction.toDecimal(fractionPrice[0], fractionPrice[1]),
                        };
                    } else if (!result.spPrice.includes('/')) {
                        const fraction = odds.decimal.toFractional(result.spPrice).simplify();
                        leg.spPrice = {
                            f: fraction.n + '/' + fraction.d,
                            d: parseFloat(result.spPrice, 10),
                        };
                    }
                }
            }

            if (result.priceType) {
                leg.priceType = result.priceType;
            }

            if (result.winReduction) {
                leg.result.winReduction = result.winReduction;
            }

            if (result.placeReduction) {
                leg.result.placeReduction = result.placeReduction;
            }

            if (result.r4Deductions) {
                leg.result.r4Deductions = parseFloat(result.r4Deductions);
            }

            if (bet.eachWay && result.eachWayReduction) {
                leg.eachWayReduction = result.eachWayReduction;
            }
        });

        for (const leg of legs) {
            if (!leg.result || !leg.result.type) {
                errors['Missing leg result'] = true;
            }

            if (leg.result && leg.result.type === 'place' && !leg.result.place) {
                errors['Missing place in leg result'] = true;
            }

            const ALLOWED_LEG_FIELDS = ['id', 'type', 'price', 'spPrice', 'priceType', 'eachWayReduction', 'result'];

            Object.keys(leg).forEach((key) => {
                if (ALLOWED_LEG_FIELDS.indexOf(key) === -1) {
                    delete leg[key];
                }
            });

            if (leg.price) {
                delete leg.price.fractionalNumerator;
                delete leg.price.fractionalDenominator;
            }
        }

        return {
            legs,
            errors: Object.keys(errors),
        };
    }

    updateLegResult(bet, index, data) {
        if (!this.results[bet.id]) {
            this.results[bet.id] = {};
        }

        this.results[bet.id][index] = data;

        this.calculateBetPayout(bet);
    }

    onQueryAudits(id, topic, tag) {
        return (e) => {
            const { onQueryAuditsRequest } = this.props;

            e.preventDefault();

            if (onQueryAuditsRequest) {
                onQueryAuditsRequest(id, { topics: [topic], tags: [tag] });
            }
        };
    }

    getType(bet) {
        switch (bet.type) {
            case 'FC':
                return 'forecast';
            case 'RFC':
                return 'forecast';
            case 'CFC':
                return 'forecast';
            case 'TC':
                return 'tricast';
            case 'CTC':
                return 'tricast';
            default:
                return false;
        }
    }

    getDividends(bet) {
        const fc = (leg) => leg.result.dividends.forecast[0].dividend;
        const tc = (leg) => leg.result.dividends.tricast[0].dividend;

        const type = this.getType(bet);

        const dividend = bet.legs
            .map((leg) => {
                let res = null;

                try {
                    if (type === 'forecast') {
                        res = fc(leg);
                    } else if (type === 'tricast') {
                        res = tc(leg);
                    }
                } catch (err) {
                    res = null;
                }
                return res;
            })
            .find((e) => e != null);

        return dividend ? dividend : 'n/a';
    }

    getExpandedRow(bet) {
        const { manualSettlements, payouts, bonusList } = this.props;
        let overlay;
        if (bet.status === 'cancelled') {
            overlay = 'Cancelled';
        } else if (bet.status === 'settled') {
            overlay = 'Settled';
        }

        if (overlay) {
            if (bet.settledBy) {
                overlay += ' by ' + bet.settledBy.name;
            }

            overlay = (
                <div
                    className='bet-search-results__overlay'
                    data-content={overlay}
                    data-test='bet-search-results-overlay'
                />
            );
        }

        const isUnsettlementPossible = bet.status === 'settled' && moment().isSame(bet.settledAt, 'day');

        if (isUnsettlementPossible) {
            overlay = (
                <div className='bet-search-results__unsettlement-box'>
                    {overlay}
                    <button
                        className='btn'
                        onClick={this.unsettleBet.bind(this, bet)}
                    >
                        Unsettle
                    </button>
                </div>
            );
        }

        const hasPayout = !this.getLegResults(bet).errors.length;
        let calculatedPayout = payouts.getIn([bet.id, 'payout']);

        if ((hasPayout && payouts.getIn([bet.id, 'payout'])) !== false && bet.status !== 'settled') {
            calculatedPayout = formatAmountWithCurrency(bet.currency, new Amount(calculatedPayout ?? '0'));
        } else if (typeof this.props.bets.getIn([bet.id, 'payout']) === 'string') {
            calculatedPayout = formatAmountWithCurrency(
                bet.currency,
                new Amount(this.props.bets.getIn([bet.id, 'payout']) ?? '0')
            );
        } else {
            calculatedPayout = 'n/a';
        }

        const notPermitted = !this.props.permissions.get('betting/settlement');

        const openCustomer = () => {
            this.appState.reduxAction.customersActionsOpenRequest(bet.account.id);
        };

        return (
            <div className='row'>
                {overlay}

                <div className='col-1'>
                    <ul className='bet-search-results__info'>
                        <li data-test='bet-id'>Bet ID: {bet.id}</li>
                        <li>Bet taken by: {(bet.placedBy && bet.placedBy.name) || '--'}</li>
                        <li>Bet offered by: {(bet.offeredBy && bet.offeredBy.name) || '--'}</li>
                        <li>Status: {bet.status}</li>
                        <li
                            className='audit-btn'
                            onClick={this.onQueryAudits('betting_bets_bet-' + bet.id, 'betting_bets', 'bet-' + bet.id)}
                        >
                            Audit
                        </li>
                        <ActiveListElement
                            data-test='user-account-id'
                            onClick={openCustomer}
                        >
                            Account ID: {bet.account.id}
                        </ActiveListElement>
                    </ul>
                </div>
                <div className='col-1'>
                    <CommentBetForm
                        data={bet}
                        className='betSearchResultForm'
                        onSubmit={this.commentBet}
                        onCopyIsonis={this.getIsonisValue}
                    />
                    <ParkBetForm
                        data={{ status: bet.status === 'parked' }}
                        className='betSearchResultForm'
                        onChange={(field, value) => this.parkBet(bet.id, value)}
                    />
                </div>
                {['FC', 'TC', 'RFC', 'CFC', 'CTC'].includes(bet.type) ? (
                    <div className='col-1 dividends'>
                        <p>
                            <strong>Dividends:</strong>
                        </p>
                        <p>
                            <small>{this.getDividends(bet)}</small>
                        </p>
                    </div>
                ) : undefined}
                <div className='col-7'>
                    {bet.legs.map((leg, idx) => (
                        <LegResultForm
                            key={leg.id}
                            eachWay={bet.eachWay}
                            data={convertLeg(leg)}
                            bonuses={
                                bet.transaction && bet.transaction.tags && bet.transaction.tags.bonuses.length > 0
                                    ? bet.transaction.tags.bonuses
                                    : []
                            }
                            currency={bet.currency}
                            onChange={(field, value, data) => this.updateLegResult(bet, idx, data)}
                            bonusList={bonusList}
                            legId={leg.id}
                            betId={bet.id}
                            setIsonis={this.setIsonisValue}
                            universe={this.appState.configState.universe}
                        />
                    ))}
                </div>
                <div className={`col-1 bet-search-results__settlement-form ${notPermitted ? 'not-permitted' : ''}`}>
                    <h4>Payout: {calculatedPayout}</h4>
                    <a
                        href='#'
                        className='btn'
                        onClick={(e) => {
                            e.preventDefault();
                            this.settleBet(bet);
                        }}
                    >
                        Settle bet
                    </a>
                    <a
                        href='#'
                        className='btn'
                        onClick={(e) => {
                            e.preventDefault();
                            this.cancelBet(bet.id);
                        }}
                    >
                        Cancel bet
                    </a>
                </div>
                <div className={`col-1 ${notPermitted ? 'not-permitted' : ''}`}>
                    <ManualSettlementForm
                        className='manualSettlementForm'
                        disabled={manualSettlements.getIn([bet.id, 'state']) === 'IN_PROGRESS'}
                        onSubmit={({ payout }) => {
                            this.settleManually(
                                bet.id,
                                $appState.configState.precision.valueOldFormat(new Amount(payout))
                            );
                        }}
                    />
                </div>
            </div>
        );
    }

    splitRow(bet) {
        if (bet.type === 'RAB' || bet.type === 'BB') {
            if (bet.legs[0].selections !== 1) {
                return bet.legs[0].selections.map((selection, index) => {
                    const row = Object.assign({}, bet);

                    row.legs = [selection];
                    row.legs[0].event = bet.legs[0].event;
                    row.legs[0].priceType = bet.legs[0].priceType;
                    row.legs[0].price = bet.legs[0].price;
                    row.legs[0].competition = bet.legs[0].competition;
                    row.legs[0].sport = bet.legs[0].sport;

                    if (index) {
                        delete row.placedAt;
                        delete row.account;
                        delete row.stakeFactor;
                        delete row.eachWay;
                        delete row.type;
                        delete row.stakePerLine;
                        delete row.totalStake;
                        delete row.payout;
                        delete row.maxBet;
                        delete row.channel;
                        delete row.eachWay;
                    }
                    return row;
                });
            }

            return [bet];
        }

        if (bet.legs.length === 1) {
            return [bet];
        }

        return bet.legs.map((leg, index) => {
            const row = Object.assign({}, bet);
            row.legs = [leg];

            if (index) {
                delete row.placedAt;
                delete row.account;
                delete row.stakeFactor;
                delete row.eachWay;
                delete row.type;
                delete row.stakePerLine;
                delete row.totalStake;
                delete row.payout;
                delete row.maxBet;
                delete row.channel;
                delete row.eachWay;
            }

            return row;
        });
    }

    render() {
        const { bets } = this.state;
        const { isSpColumn } = this.props;
        const columnsToDisplay = isSpColumn === true ? COLUMNS_WITH_SP : COLUMNS;

        return (
            <div className='bet-search-results'>
                <SimpleDataTable
                    className='simple-data-table-container--fixed zebra-table'
                    header={true}
                    stickyHeader={true}
                    stickyHeaderNew={true}
                    columns={columnsToDisplay}
                    data={bets}
                    expanded={this.getExpandedRow.bind(this)}
                    splitRow={this.splitRow.bind(this)}
                />
            </div>
        );
    }
}

export default BetSearchResults;
